import { useQuery } from '@tanstack/react-query';
import { api, GameStateResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseAdminGameStatesReturn {
  states: GameStateResponse[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useAdminGameStates(username: string): UseAdminGameStatesReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.gameState.adminList({ username }),
    queryFn: () => api.adminListGameStates(username, { limit: 100 }),
    enabled: !!username,
  });

  return {
    states: data?.states ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load game states' : null,
    refresh: () => {
      refetch();
    },
  };
}
